<template>
	<BaseMultiSelect
		:searchable="true"
		:placeholder="
			isAll
				? `Alle ${props.terms?.department?.multi}`
				: `Vælg ${props.terms?.department?.single}`
		"
		:options="options"
		v-if="(isAll && options.length > 1) || !isAll"
		@option:selected="($event) => $emit('change', $event)"
	></BaseMultiSelect>
</template>
<script setup>
import BaseMultiSelect from "@elements/select/BaseSingleSelect.vue";
import Service from "@services/DepartmentService";
import { onMounted, ref } from "vue";
import TemplateService from "../../../../services/TemplateService";
const props = defineProps({
	isAll: {
		type: Boolean,
		default: true,
	},
	isAddTemplate: {
		type: Boolean,
		default: false,
	},
	hqId: {
		type: Number,
	},
	userDeps: {
		type: Array,
		default: [],
		required: false,
	},
	terms: Object,
});
const options = ref([]);

onMounted(async () => {
	await populateOptions();
});

const populateOptions = async () => {
	const service = new Service();
	const tempService = new TemplateService();
	const departments = await service.getAll();
	if (props.isAll) {
		options.value.push({ label: "Alle afdelinger", option: "" });
	}
	if (props.isAddTemplate) {
		await tempService
			.getTemplateDepartments(props.hqId)
			.then((response) => {
				response.data.forEach((department) => {
					const option = {
						label: department.dep_name,
						option: department.dep_id,
					};
					options.value.push(option);
				});
			});
	} else if (props.userDeps.length > 0) {
		departments.forEach((department) => {
			if (props.userDeps.includes(department.dep_id)) {
				const option = {
					label: department.dep_name,
					option: department.dep_id,
				};
				options.value.push(option);
			}
		});
	} else {
		departments.forEach((department) => {
			const option = {
				label: department.dep_name,
				option: department.dep_id,
			};
			options.value.push(option);
		});
	}
};
defineExpose({ options });
</script>
<style>
@import url("/frontend/public/css/app.css");
</style>
